import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { SITE } from "@/lib/site";
import StormLayers from "@/components/cinema/StormLayers";

// Living hero background: parallax + Ken Burns photo with canvas rain, drifting fog and lightning.
// If SITE.heroVideo is set, a muted looping clip replaces the animated photo.
export default function HeroParallaxBg({ src }) {
  const reduce = useReducedMotion();
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 1000], [0, 260]);

  return (
    <motion.div
      aria-hidden
      className="absolute -inset-y-[18%] inset-x-0 will-change-transform"
      style={{ y: reduce ? 0 : y }}
      data-testid="hero-parallax-bg"
    >
      {SITE.heroVideo ? (
        <video src={SITE.heroVideo} poster={src} autoPlay muted loop playsInline data-testid="hero-video" />
      ) : (
        <>
          <div className={`absolute inset-0 bg-cover bg-center ${reduce ? "" : "hero-kenburns"}`} style={{ backgroundImage: `url(${src})` }} />
          <StormLayers />
        </>
      )}
    </motion.div>
  );
}
